import { loanInfoCardsWrapperBaseStyles } from '@sharedCR/loanSummary/LoanInfoCards';

export const getOverviewWrapperStyles = length => ({
  ...loanInfoCardsWrapperBaseStyles,
  gridTemplateColumns: {
    xs: '1fr',
    md: `repeat(${length}, 1fr)`,
  },
});

export const overviewCardStyles = {
  padding: '4px 8px',
};
